var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSurveyStatus = function SvgSurveyStatus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "currentColor",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#959595",
    strokeLinecap: "square",
    strokeWidth: 3,
    d: "M4 5h21v21H4zm33 33h21v21H37zM4 38h21v21H4zm33-23 8 8L60 5"
  }))));
};
export { SvgSurveyStatus as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMGg2NHY2NEgweiIvPgogICAgICAgIDxnIHN0cm9rZT0iIzk1OTU5NSIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgc3Ryb2tlLXdpZHRoPSIzIj4KICAgICAgICAgICAgPHBhdGggZD0iTTQgNWgyMXYyMUg0ek0zNyAzOGgyMXYyMUgzN3pNNCAzOGgyMXYyMUg0ek0zNyAxNWw4IDhMNjAgNSIvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";